import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import MessageSideNav from "../../components/libs/MessageSideNav";
import {
  MessageContainer,
  MessageNav,
  MessageContent,
  MessageFooter,
  SendMessageContainer,
} from "./style";
import PngLogo from "../../assets/images/png/luaa_logo.png";
import ChatItem from "./ChatItem";
import { FaRegPaperPlane } from "react-icons/fa";
import BottomNavBar from "../../components/libs/BottomNavBar";
import { over } from "stompjs";
import SockJs from "sockjs-client";
import TokenHelpers from "../../utils/helpers/tokenHelper";
import {
  fetchUserPrivateChats,
  fetchUserFriends,
  findChatMessage,
  setActiveTab,
} from "../../actions/chat.action";
import toast from "react-hot-toast";
import { getBaseUrl } from "../../services/baseUrl";

let stompClient = null;
const Message = () => {
  const dispatch = useDispatch();
  const profile = useSelector(({ profileReducer }) => profileReducer);
  const {
    chat: {
      privateUserChats,
      messageList,
      messageLoading,
      friends,
      friendsLoading,
      activeTab,
      activeTabMap,
    },
  } = useSelector(({ chatReducer }) => ({
    chat: chatReducer,
  }));

  const matricNumber = TokenHelpers.getUserDetails().matric_number;
  const [publicChats, setPublicChats] = useState([]);
  const [tab, setTab] = useState("CHATROOM");
  const [userData, setUserData] = useState({
    userName: "",
    receiverName: "",
    connected: false,
    message: "",
    id: "",
    name: "",
    matricNumber: "",
  });

  useEffect(() => {
    registerUser();
    setUserData({ ...userData, matricNumber: matricNumber });
    dispatch(fetchUserFriends());
  }, []);

  const registerUser = () => {
    const url = getBaseUrl();
    let Sock = new SockJs(`${url}/ws`);
    stompClient = over(Sock);
    stompClient.connect({}, onConnected, onError);
  };

  const onConnected = () => {
    setUserData({ ...userData, connected: true });
    stompClient.subscribe("/chatroom/public", onPublicMessageReceived);
    stompClient.subscribe(
      "/user/" + matricNumber + "/queue/messages",
      onPrivateMessageReceived
    );
  };

  const handleItemClick = (item) => {
    const data = {
      fullName: item.fullName,
      profileImage: item.profileImage === null ? PngLogo : item.profileImage,
      matricNumber: item.matricNumber,
      id: item.id,
    };
    dispatch(setActiveTab(data));
    setTab(item.matricNumber);
    dispatch(fetchUserPrivateChats(item.id, item.matricNumber));
  };

  const onPublicMessageReceived = (payload) => {
    let payloadData = JSON.parse(payload.body);
    switch (payloadData.messageType) {
      case "JOIN":
        if (!privateUserChats.get(payloadData.senderName)) {
          privateUserChats.set(payloadData.senderName, []);
          // setPrivateChats(new Map(privateUserChats));
        }
        break;
      case "CHAT":
        publicChats.push(payloadData);
        setPublicChats([...publicChats]);
        break;
    }
  };

  const onPrivateMessageReceived = (payload) => {
    let notification = JSON.parse(payload.body);
    console.log("activeTabMap ", activeTabMap);
    if (
      activeTabMap.get(notification.senderMatricNumber) ===
      notification.senderMatricNumber
    ) {
      dispatch(findChatMessage(notification.id));
    } else {
      toast.success("Received a new message from " + notification.senderName);
    }
  };

  const onError = (err) => {
    console.log("error ===> ", err);
  };

  const handleSetMessage = (message) => {
    setUserData({ ...userData, message: message });
  };

  const sendPrivateMessage = () => {
    if (stompClient && userData.message.trim() !== "") {
      const chatMessage = {
        senderId: profile.userData.id,
        receiverId: activeTab.id,
        senderName: matricNumber,
        senderMatricNumber: matricNumber,
        receiverName: activeTab.fullName,
        receiverMatricNumber: activeTab.matricNumber,
        message: userData.message,
        timestamp: new Date(),
      };
      if (matricNumber !== tab) {
        if (tab === "CHATROOM") {
          publicChats.push(chatMessage);
          stompClient.send("/app/message", {}, JSON.stringify(chatMessage));
        } else {
          if (privateUserChats.has(tab)) {
            privateUserChats.get(tab).push(chatMessage);
          } else {
            privateUserChats.set(tab, [chatMessage]);
          }
          stompClient.send(
            "/app/private-message",
            {},
            JSON.stringify(chatMessage)
          );
        }
        setUserData({ ...userData, message: "" });
      }
    }
  };

  return (
    <>
      <MessageContainer>
        <MessageSideNav
          users={friends}
          handleItemClick={handleItemClick}
          activeUserMatricNumber={matricNumber}
          loading={friendsLoading}
        />
        <div
          style={{
            position: "relative",
          }}
        >
          <MessageNav>
            <img src={activeTab.profileImage} alt="profile-image" />
            <div>{activeTab.fullName}</div>
          </MessageNav>
          <div
            style={{
              position: "relative",
              height: "100%",
              background: "#edf0f4",
            }}
          >
            {tab === "CHATROOM" ? (
              <MessageContent>
                {publicChats.map((chat, index) => (
                  <ChatItem key={index} item={chat} />
                ))}
              </MessageContent>
            ) : (
              <>
                {messageLoading ? (
                  "Loading..."
                ) : (
                  <>
                    <MessageContent>
                      {privateUserChats.has(tab) &&
                        [...privateUserChats.get(tab)].map((chat, index) => (
                          <ChatItem key={index} item={chat} />
                        ))}
                    </MessageContent>
                  </>
                )}
              </>
            )}
            <MessageFooter>
              <SendMessageContainer>
                <input
                  type="text"
                  placeholder="Type a message here"
                  onChange={(e) => handleSetMessage(e.target.value)}
                  value={userData.message}
                />
                <button
                  onClick={() => sendPrivateMessage()}
                  style={{ backgroundColor: "#1a5304", color: "#fff" }}
                >
                  <FaRegPaperPlane />
                </button>
              </SendMessageContainer>
            </MessageFooter>
          </div>
        </div>
      </MessageContainer>
      <BottomNavBar />
    </>
  );
};

export default Message;
